import type { SuccessionAllocationMode } from '@/api/generated/model';
import { Checkbox } from '@/components/ui/checkbox';
import { useLanguage } from '@/i18n/language-hooks';
import { cn } from '@/lib/utils';

interface SuccessionModeToggleProps {
  value: SuccessionAllocationMode;
  onChange: (mode: SuccessionAllocationMode) => void;
  disabled?: boolean;
}

export function SuccessionModeToggle({ value, onChange, disabled }: SuccessionModeToggleProps) {
  const { t } = useLanguage();
  const byAccount = value === 'byAccount';

  return (
    <label
      className={cn(
        'flex items-start gap-3 text-sm',
        disabled ? 'pointer-events-none opacity-80' : 'cursor-pointer'
      )}
    >
      <Checkbox
        checked={byAccount}
        disabled={disabled}
        onCheckedChange={(checked) => onChange(checked === true ? 'byAccount' : 'simple')}
        aria-label={t('planning.succession.modeByAccount')}
      />
      <span className='flex min-w-0 flex-col gap-0.5'>
        <span className='text-fin-white font-medium'>{t('planning.succession.modeByAccount')}</span>
        <span className='text-muted-foreground text-xs'>
          {t('planning.succession.remainingAccountsHint')}
        </span>
      </span>
    </label>
  );
}
